import React from 'react';

const Cheque = (props) => {
    return (
        <div
            className="border border-gray-800 bg-white flex items-center justify-center shadow-lg"
            style={{ width: "202mm", height: "92mm", position: "relative" }}
        >
            <div className="absolute" style={{ top: "9mm", right: "9mm" }}>
                <p className="text-sm"><strong>{props.date}</strong></p>
            </div>
            <div className="absolute" style={{ top: "20mm", left: "30mm" }}>
                <p className="text-sm"><strong>{props.partyName}</strong></p>
            </div>
            <div className="absolute" style={{ top: "30mm", left: "35mm" }}>
                <p className="text-sm"><strong>{props.amountInWords}</strong></p>
            </div>
            <div className="absolute" style={{ top: "36mm", right: "15mm" }}>
                <p className="text-sm"><strong>{props.amount}</strong></p>
            </div>
            <div className="absolute" style={{ bottom: "25mm", margin: "0 auto" }}>
                <p className="text-sm"><strong>{props.accountType}</strong></p>
            </div>
        </div>
    );
};

export default Cheque;
